export const STATUS_PILL = {
  pending: { label: 'Queued', cls: 'bg-white/10 text-white/70' },
  dialing: { label: 'Dialing', cls: 'bg-blue-500/20 text-blue-300 animate-pulse' },
  ringing: { label: 'Ringing', cls: 'bg-blue-500/25 text-blue-200 animate-pulse' },
  in_progress: { label: 'Live', cls: 'bg-emerald-500/25 text-emerald-200' },
  connected: { label: 'Connected', cls: 'bg-emerald-500/30 text-emerald-100 font-semibold' },
  no_answer: { label: 'No answer', cls: 'bg-amber-500/15 text-amber-300' },
  busy: { label: 'Busy', cls: 'bg-amber-500/15 text-amber-300' },
  voicemail: { label: 'Voicemail', cls: 'bg-amber-500/20 text-amber-200' },
  failed: { label: 'Failed', cls: 'bg-red-500/20 text-red-300' },
  cancelled: { label: 'Cancelled', cls: 'bg-civix-purple/20 text-civix-purple' },
  exhausted: { label: 'No answer', cls: 'bg-white/10 text-white/50' },
};

export function formatPhone(p) {
  if (!p) return '';
  const digits = String(p).replace(/\D/g, '');
  if (digits.length === 11 && digits.startsWith('1')) {
    return `(${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7)}`;
  }
  if (digits.length === 10) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  }
  return p;
}

export const CONCURRENCY_CHOICES = [1, 2, 3, 4, 5];

export const CONCURRENCY_LABELS = {
  1: '1 Line (Single)',
  2: '2 Lines',
  3: '3 Lines',
  4: '4 Lines',
  5: '5 Lines',
};

export const REDIAL_CHOICES = [
  { value: 1, label: '1x', sub: 'Single', full: 'Single Dial (1x)' },
  { value: 2, label: '2x', sub: 'Double', full: 'Double Dial (2x)' },
  { value: 3, label: '3x', sub: 'Triple', full: 'Triple Dial (3x)' },
];

export const SOFTPHONE_NOT_READY_MSG =
  "Your phone isn't connected — open the phone panel and allow microphone access, then try again";
export const MIC_DENIED_MSG =
  "Microphone access is blocked — click the mic icon in your browser's address bar to allow, then try again";
